import React from 'react'
import {connect} from 'react-redux'
import { Field,reduxForm,formValueSelector } from 'redux-form'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import CountDownButton from '../../../uis/countDownButton'
import { PHONE_REGEXP } from '../../../util/regExp'
import {getVerification} from '../reducers/user'

const validate = ({username,phone,password,comfirmpwd,verification}) => {
    const errors = {}
    if (!username) {
        errors.username = '必填'
    }
    if (!phone) {
        errors.phone = '必填'
    } else if (!PHONE_REGEXP.test(phone)) {
        errors.phone = '无效的手机号'
    }
    if (!password) {
        errors.password = '必填'
    } else if (!/^(\w){6,12}$/i.test(password)) {
        errors.password = '密码必须为6-12位的数字，字母或下划线'
    }
    // if (!comfirmpwd) {
    //     errors.comfirmpwd = '必填'
    // } else if (comfirmpwd !== password) {
    //     errors.comfirmpwd = '两次输入密码不同'
    // }
    if (!verification) {
        errors.verification = '必填'
    }
    return errors
}

const renderField = ({input,label,type,meta:{ touched,error }}) => (
    <div>
        <TextField 
            {...input}
            label={label}
            onChange={input.onChange}
            fullWidth={input.name === 'verification' ? false : true}
            type={type}
            margin="normal"                         
            required  
            helperText={touched && error}   
            FormHelperTextProps={{style: {color: '#F96487'}}}            
        />
    </div>
)

class SignUpForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            countdownButtonDisabled: true
        }
    }
    getVerification() {
        const {dispatch,phoneValue,form} = this.props;
        dispatch(getVerification(phoneValue,form))
    }
    onChange = (time) => {
        return time ? `重新发送${time-1}秒` : ''      
    }
    userPhoneInput(value) {
        if (PHONE_REGEXP.test(value)) {
            this.setState({ countdownButtonDisabled: false })
        } else {
          this.setState({ countdownButtonDisabled: true })
        }
    }
    render() {
        const { submitting,handleSubmit,phoneValue } = this.props;
        return (
            <form onSubmit={handleSubmit} noValidate className="loginForm">
                <Field name="username" component={renderField} type="text" label="用户名" />
                <Field name="phone" component={renderField} type="text" label="手机号码" onChange={(e)=>this.userPhoneInput(e.target.value)} />
                <div className="form-verification">
                    <Field name="verification" component={renderField} type="text" label="短信验证码" />
                    <CountDownButton 
                        disabled={this.state.countdownButtonDisabled}
                        phoneValue={phoneValue}
                        time={5}
                        text={'获取短信验证码'}
                        onChange={this.onChange.bind(this)}
                        onPress={this.getVerification.bind(this)}
                    />          
                </div>     
                <Field name="password" component={renderField} type="password" label="密码" />
                {/* <Field name="comfirmpwd" component={renderField} type="password" label="确认密码" /> */}
                <div className="user-actions">
                    <Button 
                        variant="raised" 
                        color="primary" 
                        style={{background: '#92489f'}}
                        fullWidth 
                        disabled={submitting}
                        type="submit"
                    >
                        注册
                    </Button>
                </div>
            </form>
        )
    }  
}
const selector = formValueSelector('signUpForm')
SignUpForm = connect(state => {
    return {
        phoneValue: selector(state, 'phone')
    }
})(SignUpForm)

export default reduxForm({
    form: 'signUpForm',
    validate
})(SignUpForm)


// WEBPACK FOOTER //
// ./src/pages/sign/components/signUpForm.js